// extracted by mini-css-extract-plugin
export var root = "MarkdownHR-module--root--bee14";